import React from 'react';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { useLaborProductivityDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/store/laborProductivityDashboard.store';
import { HORIZONTAL_BAR_RIGHT_MARGIN } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/LaborProductivityDashboard.constants';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborProductivityDashboard/LaborProductivityDashboard.styled';

export const ActiveMembersByPositionChart: React.FC = () => {
  const data = useLaborProductivityDashboardStore((s) => s.activeMembersByPosition);
  const page = useLaborProductivityDashboardStore((s) => s.activeByPositionPage);
  const totalPages = useLaborProductivityDashboardStore((s) => s.activeByPositionTotalPages);
  const loadingMore = useLaborProductivityDashboardStore((s) => s.activeByPositionLoadingMore);
  const loadMore = useLaborProductivityDashboardStore((s) => s.loadMoreActiveByPosition);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available for the selected filters.</EmptyStateContainer>;
  }

  const barColor = palette.chartColors[0];

  const items: HorizontalBarItem[] = data.map((d) => ({
    label: d.position,
    value: d.count,
    valueLabel: `${d.count}`,
    ariaLabel: `${d.position}: ${d.count} active members`,
    tooltipHtml: `<strong>${d.position}</strong><br/>Active Members: ${d.count}`,
    barColor,
  }));

  return (
    <HorizontalBarChart
      items={items}
      rightMargin={HORIZONTAL_BAR_RIGHT_MARGIN}
      leftMargin={170}
      wrapLabels
      ariaLabel="Active team members by position chart"
      scrollable
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
